<div class="flex flex-col gap-6 p-2 sm:p-4 h-full overflow-y-auto">

    <!-- Plan -->
    <div
        class="bg-white border border-gray-200 shadow-sm rounded-base p-2 sm:p-6 flex flex-col sm:flex-row sm:items-center gap-2">
        <div class="flex items-start gap-4 flex-1 min-w-0">
            <div class="flex flex-col gap-0.5 min-w-0">
                <span class="text-base font-bold text-surface-900 truncate">{{ planName }}</span>
                @if (billingTermLabel) {
                <span class="text-sm font-semibold text-gray-700">{{ billingTermLabel }}</span>
                }
                @if (isTrial && trialEndDate) {
                <span class="text-sm text-amber-600 mt-0.5 font-medium">
                    Trial ends on {{ trialEndDate | date:'MMM d, yyyy' }}
                </span>
                } @else if (isCancelPending && cancelAtDate) {
                <span class="text-sm text-gray-500 mt-0.5">
                    Cancellation date: {{ cancelAtDate | date:'MMM d, yyyy' }}
                </span>
                } @else if (nextBillingDate) {
                <span class="text-sm text-gray-500 mt-0.5">
                    Next billing date: {{ nextBillingDate | date:'MMM d, yyyy' }}
                </span>
                }
            </div>
        </div>
        <div class="sm:flex-shrink-0">
            <app-button label="Manage Plan" variant="outlined" severity="primary" size="default"
                (clicked)="goToPricing()" />
        </div>
    </div>

    <!-- Cancelled payment notice (only when cancel is pending) -->
    @if (isCancelPending) {
    <div class="bg-white border border-gray-200 rounded-base p-2 sm:p-6 flex flex-col gap-2">
        <span class="text-base font-bold text-surface-900">Payment</span>
        <div class="flex flex-col sm:flex-row sm:items-center gap-4">
            <div class="flex items-start gap-2 flex-1 min-w-0">
                <div class="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-lg bg-gray-100">
                    <app-icon type="x" source="lucide" size="default" class="text-black" />
                </div>
                <div class="flex flex-col gap-0.5">
                    <span class="text-sm font-semibold text-surface-900">Subscription canceled</span>
                    @if (cancelAtDate) {
                    <span class="text-sm text-surface-400">Plan ends on {{ cancelAtDate | date:'MMM d, yyyy' }}</span>
                    }
                </div>
            </div>
            <div class="sm:flex-shrink-0">
                <app-button label="Resubscribe" variant="filled" severity="primary" size="default"
                    (clicked)="goToPricing()" />
            </div>
        </div>
    </div>
    }

    <!-- Invoices table -->
    <div class="flex flex-col gap-2">
        <span class="text-base font-bold text-surface-900">Invoices</span>
        <app-data-table [data]="invoices" [columns]="invoiceColumns" [config]="invoiceTableConfig"
            [customTemplates]="customTemplates" />
    </div>

</div>

<!-- Custom cell templates -->
<ng-template #dateCellRef let-row="$implicit">
    <span class="text-sm text-surface-700">{{ row.date | date:'MMM d, yyyy' }}</span>
</ng-template>

<ng-template #typeCellRef let-row="$implicit">
    <span class="text-sm text-surface-700 capitalize">{{ row.type || '—' }}</span>
</ng-template>

<ng-template #totalCellRef let-row="$implicit">
    @if (row.total !== null) {
    <span class="text-sm font-medium text-surface-900">
        {{ row.total | currency:(row.currency || 'USD'):'symbol':'1.2-2' }}
    </span>
    } @else {
    <span class="text-sm text-surface-400">—</span>
    }
</ng-template>

<ng-template #statusCellRef let-row="$implicit">
    <span class="inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-medium"
        [ngClass]="statusClass(row.status)">
        {{ statusLabel(row.status) }}
    </span>
</ng-template>

<ng-template #actionCellRef let-row="$implicit">
    @if(row.showAction) {
    <app-button label="View" variant="outlined" severity="contrast" size="sm" (clicked)="onViewInvoice(row)" />
    }
</ng-template>